// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"202":"7058299b","409":"afb0dc8a"}[chunkId] + ".js";
};